import PaymentProcessors from '~/constants/PaymentProcessors'

export const shouldShowBraintreeFlow = (
  posProcessor: string | undefined,
  hasWalkerRole: boolean,
): boolean => {
  if (!posProcessor) {
    return false
  }

  if (posProcessor === PaymentProcessors.FIRST_AMERICAN) {
    return false
  }

  if (posProcessor === PaymentProcessors.BRAINTREE) {
    return true
  }

  if (posProcessor === PaymentProcessors.FA_BRAINTREE) {
    return hasWalkerRole
  }

  return false
}
